import { render } from "./RcptCreate.vue?vue&type=template&id=062884b0"
import script from "./RcptCreate.vue?vue&type=script&lang=js"
export * from "./RcptCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__